import { Helmet } from "react-helmet-async";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
  /** Single JSON-LD object or array — each entry is emitted as its own <script type="application/ld+json"> tag. */
  jsonLd?: object | object[];
  /** When true, emits noindex,nofollow robots meta. Use for draft previews. */
  noindex?: boolean;
}

const SITE_URL = "https://sandiegocoastalguide.com";
const DEFAULT_IMAGE =
  "https://sandiegocoastalguide.com/__l5e/assets-v1/04d4ba0a-5881-4340-a3f4-61c7321a4ae0/og-cover.jpg";

/** Ensure og:image URLs are absolute — social crawlers require it. */
const absolutize = (img: string) =>
  /^https?:\/\//i.test(img) ? img : `${SITE_URL}${img.startsWith("/") ? "" : "/"}${img}`;

const SeoHead = ({ title, description, path, image = DEFAULT_IMAGE, type = "website", jsonLd, noindex = false }: SeoHeadProps) => {
  const url = `${SITE_URL}${path}`;
  const absImage = absolutize(image);
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />

      {jsonLdArray.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
